export function DSLockedState() {
  // Ghost metric cards — synthetic plausible numbers
  const ghostMetrics = [
    { label: 'Mention Rate', value: '64%', sub: '1,000 queries' },
    { label: 'Top 5 Listed', value: '41%', sub: 'of mentions' },
    { label: 'Primary Rec', value: '19%', sub: 'of top-5' },
    { label: '#1 on List', value: '8%', sub: 'of primary recs' },
  ];

  // Ghost insight rows
  const ghostInsights = [
    { w: '72%', label: 'Most mentions don\'t reach primary recommendation' },
    { w: '58%', label: 'One model is inverting on key brand attributes' },
    { w: '85%', label: 'Practice-facing value proposition is under-encoded' },
  ];

  // Ghost table rows
  const ghostRows = ['Brand Attribute A', 'Brand Attribute B', 'Brand Attribute C', 'Brand Attribute D', 'Brand Attribute E'];

  return (
    <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>

      {/* ── Ghost page content (blurred + desaturated) ── */}
      <div style={{
        filter: 'blur(5px) grayscale(0.55)',
        opacity: 0.45,
        pointerEvents: 'none',
        userSelect: 'none',
      }}>

        {/* Ghost header */}
        <div style={{ padding: '32px 64px 28px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ width: 120, height: 13, borderRadius: 4, backgroundColor: 'var(--muted-foreground)', marginBottom: 14, opacity: 0.4 }} />
          <div style={{ width: '55%', height: 28, borderRadius: 6, backgroundColor: 'var(--foreground)', marginBottom: 10, opacity: 0.15 }} />
          <div style={{ width: '70%', height: 14, borderRadius: 4, backgroundColor: 'var(--muted-foreground)', marginBottom: 6, opacity: 0.25 }} />
          <div style={{ width: '50%', height: 14, borderRadius: 4, backgroundColor: 'var(--muted-foreground)', opacity: 0.2 }} />
        </div>

        {/* Ghost metric cards */}
        <div style={{ padding: '24px 64px', borderBottom: '1px solid var(--border)', display: 'flex', gap: '16px' }}>
          {ghostMetrics.map((m, i) => (
            <div key={i} style={{
              flex: 1,
              border: '1px solid var(--border)',
              borderRadius: 12,
              padding: '18px 20px',
              backgroundColor: 'var(--card)',
            }}>
              <div style={{ fontSize: 'var(--text-xs)', color: 'var(--muted-foreground)', marginBottom: 8 }}>{m.label}</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--foreground)', marginBottom: 4 }}>{m.value}</div>
              <div style={{ fontSize: 'var(--text-xs)', color: 'var(--muted-foreground)' }}>{m.sub}</div>
            </div>
          ))}
        </div>

        {/* Ghost Signal Analyst section */}
        <div style={{ padding: '28px 64px', borderBottom: '1px solid var(--border)', backgroundColor: 'rgba(126,95,224,0.03)', display: 'flex', flexDirection: 'column', gap: 14 }}>
          {/* Measurement summary */}
          <div style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '16px 20px', backgroundColor: 'var(--background)' }}>
            <div style={{ width: 140, height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.35, marginBottom: 10 }} />
            <div style={{ width: '90%', height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.2, marginBottom: 6 }} />
            <div style={{ width: '75%', height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.2 }} />
          </div>

          {/* Key Insights */}
          <div style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '16px 20px', backgroundColor: 'var(--background)' }}>
            <div style={{ width: 100, height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.35, marginBottom: 14 }} />
            {ghostInsights.map((ins, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                <div style={{ width: 32, height: 18, borderRadius: 4, backgroundColor: '#ff6d66', opacity: 0.3, flexShrink: 0 }} />
                <div style={{ flex: 1, height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.2, maxWidth: ins.w }} />
              </div>
            ))}
          </div>

          {/* Agent input */}
          <div style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '20px', backgroundColor: 'var(--background)' }}>
            <div style={{ width: '45%', height: 18, borderRadius: 4, backgroundColor: '#7e5fe0', opacity: 0.25, marginBottom: 14 }} />
            <div style={{ height: 42, borderRadius: 99, backgroundColor: 'var(--muted)', border: '1px solid var(--border)', borderLeft: '3px solid #7e5fe0', opacity: 0.5, marginBottom: 12 }} />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[0,1,2,3].map(i => (
                <div key={i} style={{ height: 56, borderRadius: 10, backgroundColor: 'var(--muted)', border: '1px solid var(--border)' }} />
              ))}
            </div>
          </div>
        </div>

        {/* Ghost tab bar */}
        <div style={{ display: 'flex', gap: 4, padding: '0 64px', borderBottom: '1px solid var(--border)', height: 48, alignItems: 'flex-end' }}>
          {['Brand Attribute Recall', 'Model Breakdown', 'Personas', 'Competitive', 'What AI Says', 'Blueprint'].map((label, i) => (
            <div key={i} style={{
              padding: '8px 16px',
              borderRadius: '6px 6px 0 0',
              backgroundColor: i === 0 ? 'var(--background)' : 'transparent',
              border: i === 0 ? '1px solid var(--border)' : 'none',
              borderBottom: i === 0 ? '1px solid var(--background)' : 'none',
              fontSize: 'var(--text-sm)',
              color: 'var(--muted-foreground)',
              whiteSpace: 'nowrap',
            }}>{label}</div>
          ))}
        </div>

        {/* Ghost heatmap table */}
        <div style={{ padding: '28px 64px' }}>
          <div style={{ width: 180, height: 13, borderRadius: 4, backgroundColor: 'var(--muted-foreground)', opacity: 0.3, marginBottom: 6 }} />
          <div style={{ width: '55%', height: 11, borderRadius: 3, backgroundColor: 'var(--muted-foreground)', opacity: 0.18, marginBottom: 20 }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {ghostRows.map((row, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '220px repeat(4, 1fr)', gap: 4, alignItems: 'center' }}>
                <div style={{ fontSize: 'var(--text-sm)', color: 'var(--muted-foreground)', opacity: 0.5, paddingRight: 12 }}>{row}</div>
                {[0,1,2,3].map(ci => (
                  <div key={ci} style={{
                    height: 36,
                    borderRadius: 6,
                    backgroundColor: ['#12b76a','#00c9c4','#28a9d2','#7e5fe0'][ci],
                    // Deterministic pick keeps the ghost heatmap stable across
                    // renders (no Math.random flicker) while still varied.
                    opacity: [0.6, 0.2, 0.45, 0.3][(i * 3 + ci * 2) % 4],
                  }} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Overlay lock card ── */}
      <div style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
      }}>
        <DeepSignalLockedCard />
      </div>
    </div>
  );
}

// The centered explainer card ("Deep Signal hasn't run... Talk to your Upmode
// team"). Exported so the same content can be popped as a modal elsewhere (e.g.
// the Performance topline locked funnel cards).
export function DeepSignalLockedCard() {
  return (
    <div style={{
      backgroundColor: 'var(--background)',
      border: '1px solid var(--border)',
      borderRadius: '16px',
      padding: '40px 44px',
      maxWidth: '480px',
      width: '100%',
      boxShadow: '0 8px 40px rgba(0,0,0,0.12)',
      textAlign: 'center',
    }}>
      {/* Lock icon in violet ring */}
      <div style={{
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: 'rgba(126,95,224,0.1)',
        border: '1px solid rgba(126,95,224,0.25)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 20px',
      }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7e5fe0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>

      <h3 style={{
        fontSize: 'var(--text-xl)',
        fontWeight: 700,
        color: 'var(--foreground)',
        marginBottom: '10px',
        lineHeight: 1.3,
      }}>
        Deep Signal hasn't run for this brand yet
      </h3>

      <p style={{
        fontSize: 'var(--text-sm)',
        color: 'var(--muted-foreground)',
        lineHeight: 1.6,
        marginBottom: '28px',
      }}>
        Deep Signal is a custom AI visibility measurement run. It maps how every major AI model reasons about your brand, scores 7 key variables, and surfaces the gaps between what AI knows and what it recommends.
      </p>

      <a
        href="mailto:hello@upmode.ai?subject=Deep Signal inquiry"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#7e5fe0',
          color: '#fff',
          fontWeight: 600,
          fontSize: 'var(--text-sm)',
          padding: '11px 24px',
          borderRadius: '8px',
          textDecoration: 'none',
          transition: 'opacity 0.15s',
        }}
        onMouseEnter={e => (e.currentTarget.style.opacity = '0.88')}
        onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
      >
        Talk to your Upmode team
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="7" y1="17" x2="17" y2="7" /><polyline points="7 7 17 7 17 17" />
        </svg>
      </a>

      <p style={{ fontSize: 'var(--text-xs)', color: 'var(--muted-foreground)', marginTop: '16px', opacity: 0.7 }}>
        Already have a run scheduled? Your data will appear here automatically.
      </p>
    </div>
  );
}
